<template>
  <div class="main-daily app-container" v-loading="httpLoading">
    <div class="main-daily-title flex-between">
      <h1>{{ $t('message.home.秒杀') }}</h1>
      <div class="all" @click="gotoCommodityPage">
        {{ $t('message.home.more' /**更多 */) }}
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="seckill-tabs">
      <div v-for="tab in tabTimes" :key="tab.id" :class="['seckill-tab', tabindex===tab.id?'active':'']" @click="switchTab(tab)">
        <div class="tab-time">{{ tab.time }}</div>
        <div class="tab-name">{{ tab.name }}</div>
      </div>
    </div>
    <div class="main-daily-content" ref="mainSeckill">
      <EsProductView v-for="(item,index) in seckillsList" :key="index + Math.random()" :item="item.goods" :marketingId="item.marketingId" marketingModeId="seckillMarketing" :marketingPrice="item.marketingPrice" :seckillable="tabindex === 1" />
    </div>
    <!-- <swiper :options="swiperOptions">
      <swiper-slide v-for="(item, index) in list" :key="index">
        <div class="main-daily-item flex-center">
          <div class="img-content">
            <img :src="item" alt="" />
          </div>
          <span class="amount">$12.00</span>
        </div>
      </swiper-slide>
    </swiper> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EsProductView from '@/components/product'
import Bus from '@/util/bus'
import {
		list
	} from "@/api/marketing/seckill_marketing.js"

export default {
  name: 'EsMainSeckill',
  components: { EsProductView },
  data() {
    return {
      httpLoading: false,
      tabTimes: [], // [{id, time, name, hour}]
      tabindex: 1,
      //秒杀请求参数
      seckillQueryParams: {
        pageNumber: '1',
        pageSize: '5',
        hour: 'ZERO',
      },
      seckillsList: [], //秒杀
    }
  },
  computed: {
    ...mapGetters('home', ['newList']),
  },
  methods: {
    // ...mapActions('home', ['requestRecommendLList', 'requestRecommendNewLList']),
    gotoCommodityPage() {
      this.$router.push('/flash-sale')
    },
    async getList(){
      try {
      this.httpLoading = true
    //   await this.requestRecommendNewLList({ type: 0 ,pageSize: 24,
    //       pageNum: 1,})
    } finally {
      this.$Gsap.from(this.$refs.mainDaily,{
        delay: 0.5,
        duration: 1,
        y: '+100',
        autoAlpha: 0,
        ease: "back.out(1.7)"
      })
      this.httpLoading = false
    }
    },

    //生成4个时段Tab：当前小时 + 后续3小时
    buildTabTimes() {
      const hourNames = ['ZERO','ONE','TWO','THREE','FOUR','FIVE','SIX','SEVEN','EIGHT','NINE','TEN','ELEVEN','TWELVE','THIRTEEN','FOURTEEN','FIFTEEN','SIXTEEN','SEVENTEEN','EIGHTEEN','NINETEEN','TWENTY','TWENTY_ONE','TWENTY_TWO','TWENTY_THREE'];
      const nowHour = new Date().getHours();
      const tabs = [];
      for (let i = 0; i < 4; i++) {
        const h = (nowHour + i) % 24;
        tabs.push({
          id: i + 1,
          time: h + ':00',
          name: i === 0 ? this.$t('message.home.seckillRushing') : this.$t('message.home.seckillWillStart'),
          hour: hourNames[h],
        });
      }
      this.tabTimes = tabs;
    },
    switchTab(tab) {
      this.tabindex = tab.id;
      this.seckillQueryParams.hour = tab.hour;
      this.seckill_list();
    },

    /**
     * 秒杀查询列表 list
     */
    seckill_list() {
      list(this.seckillQueryParams).then(response => {
        this.seckillsList = response.data.data || [];
      });
    },

  },
   mounted() {
    this.buildTabTimes();
    this.seckillQueryParams.hour = this.tabTimes[0].hour;
    this.seckill_list();
  },
}
</script>

<style lang="scss">
.main-daily {
  margin-bottom: 26px;
  &-title {
    h1 {
      font-weight: 700;
      font-size: 16px;
      color: var(--color-grey);
      margin: 24px 0;
    }
    span {
      color: var(--color-main);
      font-size: 12px;
    }
    .all {
      font-size: 12px;
      color: var(--color-main);
      cursor: pointer;
      font-weight: 400;
    }
  }
  &-item {
    flex-direction: column;
    .img-content {
      width: 100%;
      margin-bottom: 10px;
    }
    .amount {
      font-size: 16px;
      font-weight: 500;
      color: var(--color-main);
    }
  }
  &-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(228px, 190px));
    grid-column-gap: 14px;
    grid-row-gap: 20px;
    align-content: center;
    /* padding: 26px 0; */
  }
  // .swiper-container {
  //   cursor: pointer;
  //   font-size: 12px;
  //   img {
  //     max-width: 310px;
  //     max-height: 148px;
  //     object-fit: cover;
  //     width: 100%;
  //     height: 100%;
  //   }
  // }
}
.seckill-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 14px;
}
.seckill-tab {
  width: 90px;
  text-align: center;
  padding: 6px 0;
  border-radius: 4px;
  background: #f5f5f5;
  cursor: pointer;
  color: #999;
  .tab-time { font-size: 13px; font-weight: bold; }
  .tab-name { font-size: 11px; }
  &.active {
    background: linear-gradient(90deg, #ee0a24, #ff6034);
    color: #fff;
  }
}
</style>
